export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_LoadDetails.bc94d1ab.jpg";